export default __webpack_public_path__ + "static/media/qr.84fc6154.svg";